<script>
import { formatPhoneNumber } from '@utils/phone-format'
import { isProd } from '@utils/environment'

export default {
  props: {
    conflicts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      formatPhoneNumber: formatPhoneNumber,
      columns: [
        {
          title: 'Mantle IMSI #',
          dataIndex: 'imsi',
          key: 'imsi',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.imsi.localeCompare(b.imsi),
        },
        {
          title: 'Hardware IMSI #',
          dataIndex: 'hw_imsi',
          key: 'hw_imsi',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.hw_imsi.localeCompare(b.hw_imsi),
        },
        {
          title: 'Mantle Slot',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.id - b.id,
        },
        {
          title: 'Hardware',
          dataIndex: 'hardwareId',
          key: 'hardwareId',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.hardwareId.localeCompare(b.hardwareId),
          filters: isProd()
            ? [
                {
                  text: 'MD',
                  value: 'md',
                },
                {
                  text: 'CA',
                  value: 'ca',
                },
                {
                  text: 'LA',
                  value: 'la',
                },
                {
                  text: 'VA',
                  value: 'va',
                },
              ]
            : [
                {
                  text: 'LA',
                  value: 'la',
                },
                {
                  text: 'VA',
                  value: 'va',
                },
              ],
          // specify the condition of filtering result
          // here is that finding the name started with `value`
          onFilter: (value, record) => record.hardwareId.indexOf(value) === 0,
        },
        {
          title: 'Sync',
          key: 'sync',
          scopedSlots: {
            customRender: 'customRender',
          },
        },
      ],
    }
  },
  methods: {
    selectRow(record) {
      this.$emit('updateConflictConnection', record)
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
  },
}
</script>

<template>
  <a-table :data-source="conflicts" :columns="columns">
    <div
      slot="filterDropdown"
      slot-scope="{
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
        column,
      }"
      style="padding: 8px"
    >
      <a-input
        v-ant-ref="(c) => (searchInput = c)"
        :placeholder="`Search ${column.dataIndex}`"
        :value="selectedKeys[0]"
        style="display: block; width: 188px; margin-bottom: 8px"
        @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])"
        @pressEnter="
          () => handleSearch(selectedKeys, confirm, column.dataIndex)
        "
      />
      <a-button
        type="primary"
        icon="search"
        size="small"
        style="width: 90px; margin-right: 8px"
        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
      >
        Search
      </a-button>
      <a-button
        size="small"
        style="width: 90px"
        @click="() => handleReset(clearFilters)"
      >
        Reset
      </a-button>
    </div>
    <a-icon
      slot="filterIcon"
      slot-scope="filtered"
      type="search"
      :style="{ color: filtered ? '#108ee9' : undefined }"
    />
    <template slot="customRender" slot-scope="text, record, index, column">
      <span v-if="searchText && searchedColumn === column.dataIndex">
        <template
          v-for="(fragment, i) in text
            .toString()
            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
        >
          <mark
            v-if="fragment.toLowerCase() === searchText.toLowerCase()"
            :key="i"
            class="highlight"
            >{{ fragment }}</mark
          >
          <template v-else>{{ fragment }}</template>
        </template>
      </span>
      <template v-else>
        <div
          v-if="column.key === 'imsi'"
          @click="() => selectRow(record, column)"
        >
          <a @click="() => selectRow(record, column)">{{
            record.imsi.toUpperCase()
          }}</a>
        </div>
        <div v-else-if="column.key === 'mtn'">
          {{ formatPhoneNumber(text) }}
        </div>
        <div v-else-if="column.key === 'simSlot'">
          <a-tag color="red">
            {{ text }}
          </a-tag>
        </div>
        <div v-else-if="column.key === 'slot'">
          <a-tag color="green">
            {{ text }}
          </a-tag>
        </div>
        <div v-else-if="column.key === 'sync'">
          <ul class="actions">
            <li>
              <a
                href="javascript:;"
                title="Sync SIM slot"
                @click="() => selectRow(record, column)"
              >
                <a-button type="primary" icon="sync"></a-button>
              </a>
            </li>
          </ul>
        </div>
        <div v-else>
          {{ text }}
        </div>
      </template>
    </template>
  </a-table>
</template>

<style scoped>
.highlight {
  padding: 0;
  background-color: rgb(255, 192, 105);
}

#conn--container td > div {
  text-transform: uppercase;
}
</style>
